export var SearchType;
(function (SearchType) {
    SearchType["NAME"] = "name";
    SearchType["CONTENT"] = "content";
})(SearchType || (SearchType = {}));
